import React, { useState } from 'react';
import { ButtonWrapper, DropdownWrapper, Label, StyledButton, StyledRadio } from './SessionDropdownStyles';
import { ReactComponent as ArrowDown } from 'images/arrowDown.svg';
import { Button, RadioGroup } from '@trackman/web-shared-components';

interface IProps {
  isVerified: boolean;
  isPlayerTrackingVerified: boolean;
  setIsVerified: React.Dispatch<React.SetStateAction<boolean>>;
  setIsPlayerTrackingVerified: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: () => Promise<void>;
  isPlayerTrackingEnabled: boolean;
}

const SessionDropdown: React.FC<IProps> = (props) => {
  const { isVerified, isPlayerTrackingVerified, setIsVerified, setIsPlayerTrackingVerified, onSubmit, isPlayerTrackingEnabled } = props;
  const [visible, setVisible] = useState(false);

  const toggleDropdown = () => {
    setVisible((prevState) => !prevState);
  };

  return (
    <div style={{ position: 'relative' }}>
      <StyledButton intent='primary' label='Apply' onClick={toggleDropdown} width={150} icon={(fill: any) => <ArrowDown fill={fill} />} />
      {visible && (
        <DropdownWrapper>
          <div>
            <Label>Ball tracking status</Label>
            <RadioGroup>
              <StyledRadio
                value='1'
                label='Verified'
                width={200}
                withoutBorder
                reversed
                checked={isVerified}
                onChange={() => setIsVerified(true)}
              />
              <StyledRadio
                value='1'
                label='Not verified'
                width={200}
                withoutBorder
                reversed
                checked={!isVerified}
                onChange={() => setIsVerified(false)}
              />
            </RadioGroup>
          </div>
          {isPlayerTrackingEnabled && (
            <div>
              <Label>Player tracking status</Label>
              <RadioGroup>
                <StyledRadio
                  value='1'
                  label='Verified'
                  width={200}
                  withoutBorder
                  reversed
                  checked={isPlayerTrackingVerified}
                  onChange={() => setIsPlayerTrackingVerified(true)}
                />
                <StyledRadio
                  value='1'
                  label='Not verified'
                  width={200}
                  withoutBorder
                  reversed
                  checked={!isPlayerTrackingVerified}
                  onChange={() => setIsPlayerTrackingVerified(false)}
                />
              </RadioGroup>
            </div>
          )}
          <ButtonWrapper>
            <Button label='Submit' intent='primary' width={'100%'} onClick={onSubmit} />
            <Button label='Close' intent='secondary' width={'100%'} onClick={toggleDropdown} />
          </ButtonWrapper>
        </DropdownWrapper>
      )}
    </div>
  );
};

export default SessionDropdown;
